module.exports = __webpack_public_path__ + "media/images/pages/home/s4play_game-9b7cf9eacc822b4f80bb0b3e5f616943.png";